








import axios from 'axios'
import * as utils from '@ivy/fts/utils'
import { wxConfigReady } from '@ivy/fts/weixin'
import { Component, Vue, Watch } from 'vue-property-decorator'
import config from './config'
@Component({})
export default class App extends Vue {
  name: 'app'
  transitionName: 'slide-left'
  async created() {
    const href = window.location.href
    // 此处判断加个m是为了避免影响到本地启动正式环境的问题
    if (href.startsWith('http://m') && config.env === 'production') {
      window.location.href = href.replace('http://', 'https://')
    }
    await wxConfigReady()
    const pathName = window.location.pathname
    const ignorePathList = ['getInternalCouponList']
    if (!pathName || !ignorePathList.some(p => pathName.includes(p))) {
      console.log('logined,app.vue')
      await this.$store.login()
    }
    // this.$axios.get('/api/m-course/sample/hello')
  }
  @Watch('$route')
  onRouteChanged(to, from) {
    let title = this.$route.name
    document.querySelector('title').innerHTML = title || '常青藤爸爸学堂'
  }
}
console.log("Powered by ivydad")
